import { trackAnalyticEvent } from '../components/analytics/AnalyticTracker';

export default class AnalyticsLogger {
    static trackEvent(category, analyticsData) {
        trackAnalyticEvent(category, analyticsData);
    }
}
